import type { ChatExecution } from "@stockline/shared/types/ai/chat-execution"
import { CHAT_EXECUTION_TABLE } from "../../../lib/offline/resources/ai/chat-execution/db"
import { useAISync } from "../providers/AISyncProvider"

/**
 * Returns all executions for a session, sorted by createdAt DESC.
 */
export function useChatExecutions(sessionId: string | null): ChatExecution[] {
  const { reactive } = useAISync()
  const results = reactive.useQuery<ChatExecution>(
    CHAT_EXECUTION_TABLE,
    sessionId ? { sessionId, orderBy: "-createdAt" } : { sessionId: "__none__" }
  )
  return sessionId ? results : []
}

/**
 * Returns the latest execution for a session (first in DESC order).
 */
export function useLatestChatExecution(
  sessionId: string | null
): ChatExecution | null {
  const executions = useChatExecutions(sessionId)
  return executions[0] ?? null
}

/**
 * Returns a single execution by ID (Dexie primary-key live lookup).
 */
export function useChatExecution(
  executionId: string | null
): ChatExecution | null {
  const { reactive } = useAISync()
  return reactive.useOne<ChatExecution>(
    CHAT_EXECUTION_TABLE,
    executionId ?? "__none__"
  )
}
